/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import AdbIcon from '@material-ui/icons/Adb';
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
import Language from "@material-ui/icons/Language";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import LockIcon from "@material-ui/icons/Lock";
import GridOnIcon from "@material-ui/icons/GridOn";
import PermDataSettingIcon from "@material-ui/icons/PermDataSetting";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AndroidIcon from "@material-ui/icons/Android";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import Terminal from "views/Terminal/Terminal";
import UserProfile from "views/UserProfile/UserProfile.js";
import TableList from "views/TableList/TableList.js";
import Typography from "views/Typography/Typography.js";
import Icons from "views/Icons/Icons.js";
import Maps from "views/Maps/Maps.js";
import NotificationsPage from "views/Notifications/Notifications.js";
import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
import RTLPage from "views/RTLPage/RTLPage.js";
import { Lock, Shop, ShoppingCart } from "@material-ui/icons";



//                            SideBar's (Dashboard) Data

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "داشبورد",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/terminal",
    name: "Terminal",
    rtlName: "ترمینال",
    icon: TouchAppIcon,
    component: Terminal,
    layout: "/admin"
  },
  {
    path: "/smarttrade",
    name: "Smart Trade",
    rtlName: "تجارت هوشمند",
    icon: AssessmentIcon,
    component: UserProfile,
    layout: "/admin"
  },
  {
    path: "/dcabot",
    name: "DCA Bot",
    rtlName: "ربات DCA",
    icon: AdbIcon,
    component: TableList,
    layout: "/admin"
  },
  {
    path: "/myexchanges",
    name: "My Exchanges",
    rtlName: "مبادلات من",
    icon: LockIcon,
    component: Typography,
    layout: "/admin"
  },
  // {
  //   path: "/gridbot",
  //   name: "Grid bot",
  //   rtlName: "ربات Grid ",
  //   icon: GridOnIcon,
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
    
  //   path: "/marketplace",
  //   name: "Market Place",
  //   rtlName: "مارکت",
  //   icon: ShoppingCart,
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/optionsbot",
  //   name: "Options Bot",
  //   rtlName: "ربات گزینه ها",
  //   icon: PermDataSettingIcon,
  //   component: NotificationsPage,
  //   layout: "/admin"
  // },
  // {
  //   path: "/rtl-page",
  //   name: "Persian",
  //   rtlName: "فارسی",
  //   icon: Language,
  //   component: RTLPage,
  //   layout: "/rtl"
  // },
  // {
  //   path: "/upgrade-to-pro",
  //   name: "Upgrade To PRO",
  //   rtlName: "التطور للاحترافية",
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: "/admin"
  // }
];

export default dashboardRoutes;
